function renderRowChildren(h, nodes, span) {
  return nodes.map((node) =>
    h(
      'el-col',
      {
        props: {
          span: node.data.attrs.span || span,
          offset: node.data.attrs.offset || 0,
        },
      },
      [node]
    )
  )
}

import './style.scss'
import PopperJS from 'element-ui/lib/utils/popper'
import contract from './assets/contract.png'
import expand from './assets/expand.png'
export default {
  name: 'MgCollapseCard',
  props: {
    defaultExpand: {
      type: Boolean,
      default: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    span: {
      type: Number,
      default: 6,
    },
    gutter: {
      type: Number,
      default: 10,
    },
    title: {
      type: String,
      default: '',
    },
    collapsible: {
      type: Boolean,
      default: true,
    },
    showCount: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      visible: this.defaultExpand,
    }
  },
  watch: {
    defaultExpand() {
      this.handleArrowClick()
    },
  },
  computed: {
    arrowClass() {
      return this.visible ? 'el-icon-d-arrow-right' : 'el-icon-d-arrow-left'
    },
  },
  methods: {
    handleArrowClick() {
      this.visible = !this.visible
      this.$emit('change', this.visible)
    },
    handleMouseEnter(e) {
      const target = e.target.querySelector('input')
      // 文本溢出
      if (target.scrollWidth > target.clientWidth) {
        if (!this.popperElm) {
          this.popperElm = document.createElement('div')
          this.popperElm.className = 'el-tooltip__popper is-dark'
          const arrow = document.createElement('div')
          arrow.setAttribute('x-arrow', '')
          arrow.className = 'popper__arrow'
          this.popperElm.appendChild(arrow)
          const content = document.createElement('div')
          content.setAttribute('class', 'el-tooltip__popper__content')
          this.popperElm.appendChild(content)
        }
        this.popperElm.lastChild.innerText = target.value
        document.body.appendChild(this.popperElm)
        this.popperJS = new PopperJS(e.target, this.popperElm, { placement: 'top' })
      }
    },
    handleMouseLeave() {
      if (this.popperJS) {
        this.popperJS.destroy()
        this.popperJS = null
        document.body.removeChild(this.popperElm)
      }
    },
  },
  mounted() {
    function getEditableComponents(el, nodeList) {
      return Array.from(el.$children).reduce((res, node) => {
        if (['el-input', 'el-select', 'el-date-picker'].includes(node.$options._componentTag)) {
          res.push(node)
          return res
        }
        return getEditableComponents(node, res)
      }, nodeList)
    }
    this.editableComponents = getEditableComponents(this, [])
    if (this.readonly) {
      this.editableComponents.forEach((ele) => {
        ele.$el.addEventListener('mouseenter', this.handleMouseEnter)
        ele.$el.addEventListener('mouseleave', this.handleMouseLeave)
      })
      return
    }
  },
  beforeDestroy() {
    if (this.editableComponents) {
      this.editableComponents.forEach((ele) => {
        ele.$el.removeEventListener('mouseenter', this.handleMouseEnter)
        ele.$el.removeEventListener('mouseleave', this.handleMouseLeave)
      })
      this.editableComponents = null
    }
  },
  render(h) {
    const defaultList = this.$slots?.default?.filter((node) => node.context)
    const nodes = defaultList.slice(0, this.showCount)
    const defaultNodes = renderRowChildren(h, nodes, this.span)
    let otherNodes = defaultList.slice(this.showCount)
    if (otherNodes) {
      otherNodes = renderRowChildren(h, otherNodes, this.span)
    }
    // 标题右侧 slot
    const titleRight = h('div', [this.$slots?.titleRight ?? null])

    return (
      <div class={['mg-collapse-card', this.readonly ? 'readonly' : '']}>
        <div class="el-collapse-card__topbar">
          <div class="el-collapse-card__title">
            {this.collapsible && (
              <img class="icon" src={this.visible ? contract : expand} onClick={this.handleArrowClick} />
            )}
            <span class="title">{this.title}</span>
            {this.$slots?.titleSuffix && h('span', { class: 'el-collapse-card__title-suffix' }, [this.$slots.titleSuffix])}
          </div>

          {titleRight}
        </div>
        <div class="mg-collapse-card__body">
          {/* type=flex + wrap：避免默认 float 栅格在「列高不一致」时下一行挤到右侧（Windows/Electron 上更明显） */}
          {/* 不传 gutter：与历史行为一致（此前 el-row 未绑定 gutter，等效 0） */}
          <el-row type="flex" align="top" style={{ flexWrap: 'wrap' }}>
            {defaultNodes}
          </el-row>
        </div>
        <el-collapse-transition>
          <div v-show={this.visible}>
            <div class="mg-collapse-card__body">
              <el-row type="flex" align="top" style={{ flexWrap: 'wrap' }}>
                {otherNodes}
              </el-row>
            </div>
          </div>
        </el-collapse-transition>
        <i v-show={!!this.showCount} class={['mg-collapse-card__arrow', this.arrowClass]} onClick={this.handleArrowClick} />
      </div>
    )
  },
}
